import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class BillingAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = `/api/billing`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getByUserId(id, router) {
    const url = `/api/billing/user/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getById(id, router) {
    const url = `/api/billing/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  create(formData) {
    const url = `/api/billing`;
    return this.CommonAPIService.postCall(url, formData);
  }

  update(id, formData) {
    const url = `/api/billing/${id}`;
    return this.CommonAPIService.putCall(url, formData);
  }

  delete(id, router) {
    const url = `/api/billing/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  getBillingTypes(router) {
    const url = `/api/billing/types`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getBillingStatuses(router) {
    const url = `/api/billing/statuses`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getBillingItemTypes(router) {
    const url = `/api/billing/itemTypes`;
    return this.CommonAPIService.getCall(url, "", router);
  }
  getFixedCostItemsByItemType(id, router) {
    const url = `/api/billing/fixedCostItems/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }
}

export default BillingAPIService;
